import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { SortOptionsForType } from './SortOptionDefinitions';

export const WorkbookSubspaceDatasourcesSortOptions: SortOptionsForType = {
  defaultOrder: [Order.asc(OrderKeys.name)],
  options: {
    'name': SortOptions.name,
    'refresh': SortOptions.datasourceRefresh,
    'alert': SortOptions.alert
  },
  displaySortDropdown: true
};

export const WorkbookSubspaceViewsSortOptions: SortOptionsForType = {
  defaultOrder: [Order.asc(OrderKeys.index), Order.asc(OrderKeys.name)],
  options: {
    'name': SortOptions.name,
    'hits': SortOptions.hits,
    'sheet': SortOptions.sheetIndex,
  },
  displaySortDropdown: true
};
